export var VoucherType;
(function(VoucherType) {
    VoucherType[/**
     * A voucher that can be redeemed for the purchase of a ticket.
     *
     * @remarks
     * The voucher can be a VGC Ticket voucher or a VGC multi-use voucher with ticket redemptions.
     */ "Ticket"] = "Ticket";
    VoucherType[/**
     * A voucher that can be redeemed for the purchase of a subscription.
     */ "Subscription"] = "Subscription";
})(VoucherType || (VoucherType = {}));

//# sourceMappingURL=voucher-type.js.map